import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { News } from '../models/News'
import { MySixtemaDialogTitle } from './ContextSelectorDialog'
import { RecoilState, useRecoilState, useRecoilValue } from 'recoil'
import { newsImageDataSelector } from '../atoms/news'

type NewsViewDialogPropsType = {
    open: boolean,
    index: number;
    listNews: News[],
    onHandleCloseViewNews?: () => void,
    atom: RecoilState<News>
}

export const NewsViewDialog: React.FC<NewsViewDialogPropsType> = ({ open, listNews, index, onHandleCloseViewNews, atom }: NewsViewDialogPropsType) => {
    const [news, setNews] = useRecoilState<News>(atom)
    const [currentIndex, setCurrentIndex] = React.useState<number>(index)
    const {t} = useTranslation();
    const avatar = useRecoilValue(newsImageDataSelector(news?.id))
    
    const handleClose = (event: {}, reason: "backdropClick" | "escapeKeyDown") => {
        if (reason === 'escapeKeyDown') return
        onHandleCloseViewNews && onHandleCloseViewNews()
    }
    
    // console.log({news})
    // console.log({avatar})
    useEffect(() => {
        setCurrentIndex(index)
    }, [index])

    const handleNext = () => {
        setCurrentIndex(currentIndex => currentIndex + 1)
        if (currentIndex + 1 < listNews.length)
            setNews(listNews.at(currentIndex + 1)!)
    }

    const handlePrevious = () => {
        setCurrentIndex(currentIndex => currentIndex - 1)
        if (currentIndex > 0)
            setNews(listNews.at(currentIndex - 1)!)
    }

    return (
        <>
            <Dialog
                open={open}
                maxWidth='md'
                fullWidth
                onClose={handleClose}
            >
                <MySixtemaDialogTitle onClose={onHandleCloseViewNews}>
                    <Typography><span>{news?.title}</span></Typography>
                </MySixtemaDialogTitle>
                <DialogContent>
                    <Box sx={{ overflow: 'auto' }}>
                        <form>
                            <Box sx={{display: 'flex', flexDirection: 'column', width: '100%'}}>
                                <Box sx={{textAlign: 'center'}}>
                                    <h1>{news.title}</h1>
                                </Box>
                                {news?.newsImage ? 
                                    <Box sx={{display: 'flex', flexDirection: 'row', gap: 2, width: '100%'}}>
                                        <Box sx={{maxWidth: '50%'}}>
                                            <img src={avatar} style={{maxWidth: '95%' }} alt=""></img>
                                        </Box>
                                        <Box sx={{textAlign: 'left'}}>
                                            <h2>{news.subtitle}</h2>
                                            <div dangerouslySetInnerHTML={{ __html: news.body }} /> 
                                        </Box>
                                    </Box>
                                    :
                                    <Box sx={{/*textAlign: 'center',*/ width: '100%'}}>
                                        <div>
                                            <h2>{news.subtitle}</h2>
                                            <div dangerouslySetInnerHTML={{ __html: news.body }} /> 
                                        </div>
                                    </Box>
                                }
                            </Box>
                        </form>
                    </Box>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button onClick={() => { console.log('Condividi') }} variant="text">{t('Condividi')}</Button>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button color='primary' disabled={currentIndex === 0} onClick={handlePrevious} variant="text">{t('Precedente')}</Button>
                        <Button color='primary' disabled={currentIndex === listNews.length - 1} onClick={handleNext} variant="text">{t('Successivo')}</Button>
                    </Box>
                    <Button sx={{ color: 'primary' }} onClick={onHandleCloseViewNews} variant="text">{t('Chiudi')}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

